import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import {
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { Scale as HypScale } from '@hyperobjekt/scales'

const useStyles = makeStyles(theme => ({
  root: {
    '& .HypScale-root': {
      marginLeft: -5,
      height: 24,
      marginTop: 10,
      '& path.domain, g.tick line': {
        display: 'none',
      },
      '& g.tick text': {
        ...theme.typography.caption,
        fill: theme.extras.variables.colors.lightGray,
      },
      '& .HypScale-colors': {
        padding: '0 2px 0 5px !important',
        '& canvas': {
          borderRadius: 2,
        },
      },
      '& .HypScale-ticks > g': {
        transform: 'translate(7px, -4px)',
      },
      '& .HypScale-pointerWrapper': {
        transform: 'scaleX(1.5)',
        '& svg': {
          marginTop: '-2px !important',
          '& polygon': {
            stroke: 'white',
            fill: theme.extras.variables.colors.textSubtle,
          },
        },
      },
    },
  },
}))

/**
 * Static scale that renders color spectrum for Scores.
 */
const ScoreScale = ({ hoveredScore }) => {
  const classes = useStyles()

  const theme = useTheme()
  const markValue = hoveredScore

  const isMobile = useMediaQuery(
    theme.breakpoints.down('xs'),
  )

  let width = 292
  // adjust width to scale to mobile width available
  if (isMobile) {
    width = window.innerWidth - 16 * 2 + 8
  }

  return (
    <Box
      className={clsx('score-scale-parent', classes.root)}
    >
      <HypScale
        type="continuous"
        width={width}
        min={0}
        max={100}
        colors={theme.extras.ratings.scoreColors}
      >
        <HypScale.Marker value={markValue} pointer />
        <HypScale.Colors />
        <HypScale.Ticks ticks={5} />
      </HypScale>
    </Box>
  )
}

ScoreScale.propTypes = {}

export default ScoreScale
